import http from '@/utils/http'

// 登录
export function login(data){
    return http.post('/login',data)
}
export function loginxcx(data){
    return http.post('/api/login',data)
}
// 获取用户详细信息
export function getInfo(){
    return http.get('/getInfo')
}
export function getTeacherInfo(id){
    return http.get('/teacher/teacher/selectTeacherInfo/'+id)
}

// get请求
export function getNoticeList(params){
    return http.get('/notice/noticeInfo/phoneList',params)
}

// 退出登录
export function logout(){
    return http.post('/logout')
}
// 获取验证码
export function getCodeImg() {
    return http.get('/captchaImage')
    // return request({
    //   url: '/captchaImage',
    //   headers: {
    //     isToken: false
    //   },
    //   method: 'get',
    //   timeout: 20000
    // })
  }



// WEBPACK FOOTER //
// ./src/api/login.js